import React from 'react';
import { ImageProps } from '@draft-js-plugins/image/lib/Image';
import clsx from 'clsx';

// This is our custom component that will render the image
export const CustomImageComponent = React.forwardRef<HTMLImageElement, ImageProps>(
    function CustomImageComponent(props, ref) {
        const src = (props.blockProps as any)?.resizeData?.src;
        const data = props.contentState.getEntity(props.block.getEntityAt(0)).getData();
        const text = data.text;
        const link = data.link;

        // 2. The core rendering logic
        const imageElement = (
            <img
                ref={ref}
                src={src}
                alt={text || ''}
                style={props.style}
                className={clsx(props.className, props.theme?.image)} // Use the theme from the plugin
                onClick={props.onClick}
                onMouseDown={props.onMouseDown}
                onMouseLeave={props.onMouseLeave}
                onMouseMove={props.onMouseMove}
            />
        );

        // 3. Conditionally wrap the image in a link
        if (link) {
            return (
                <a
                    href={link}
                    title={text}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {imageElement}
                </a>
            );
        }

        // If there's no link, just return the image
        return imageElement;
    }
)